module.exports = __webpack_public_path__ + "img/CUERDA.ebe763ed.png";